<template>
  <div id="app">
    <div class="login-main" v-if="router === '/'">
      <login-view></login-view>
    </div>
    <div class="main" :class="[close_slide ? 'close' : '', leight ? 'slide-left-leight' : 'slide-left-dark']" v-loading.fullscreen.lock="fullscreenLoading" v-else>
        <slide-left></slide-left>
        <main-madel></main-madel>
    </div>
  </div>
</template>

<script>
import loginView from './components/login.vue'

import slideLeft from './components/slide-left'
import mainMadel from './components/main-madel'

export default {
  name: 'HelloWorld',
  data () {
    return {
      leight:false,
      close_slide:false,
      fullscreenLoading:false,
      router:''
    }
  },
  components:{
    loginView,
    slideLeft,
    mainMadel
  },
  created(){},
  methods:{
    /*asdasd(){
      this.$imgPreview("https://images.pexels.com/photos/1130847/pexels-photo-1130847.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260")
    }*/
  },
  mounted(){
    console.log(this.$lunarCalendar(new Date('2019/02/19 10:00:00').getTime()))
    this.router = this.$route.path;
    /*this.$Mathjax()
    console.log(this.$Mathjax)*/
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import url(https://fonts.googleapis.com/css?family=Open+Sans:800);
  @import './assets/iconfont-icons.css';
  @import './assets/themify-icons.css';
  @import './assets/feather-icons.css';
  @import './assets/css-plug-in-unit/reset.css';
  @import './assets/css-plug-in-unit/index.css';
</style>
<style lang="scss">
  .el-scrollbar__view{
    min-height: 100%;
  }
  .view-modal{
    padding: 10px;
    width: 100%;
    height: 100%;
    background-color: #f1f1f1;
    & > div {
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 0 4px rgba(0,0,0,0.2);
      padding: 10px;
    }
    &::after, & > div::after{
      content: '';
      width: 0;
      height: 0;
      display: block;
      clear: both;
    }
  }
</style>
<style scoped lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  width: 100%;
  height: 100%;
  .main{
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
    background: #f1f1f1;
  }
  .login-view{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue